(function () {
  var SWIPER_SRC = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
  var SWIPER_CSS = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";

  function ensureSwiperAssets(onReady) {
    if (window.Swiper) {
      onReady();
      return;
    }

    if (!document.querySelector('link[data-mm-swiper-css="true"]')) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = SWIPER_CSS;
      link.setAttribute("data-mm-swiper-css", "true");
      document.head.appendChild(link);
    }

    var existing = document.querySelector('script[data-mm-swiper-js="true"]');
    if (existing) {
      document.addEventListener("mm:swiper-ready", onReady, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.src = SWIPER_SRC;
    script.setAttribute("data-mm-swiper-js", "true");
    script.onload = function () {
      document.dispatchEvent(new CustomEvent("mm:swiper-ready"));
      onReady();
    };
    document.body.appendChild(script);
  }

  function initSection(section) {
    if (!section || section.dataset.mmTestimonialsInit === "true") return;

    var container = section.querySelector(".mm-testimonials__swiper");
    if (!container) return;

    ensureSwiperAssets(function () {
      if (section.dataset.mmTestimonialsInit === "true") return;

      var slidesCount = container.querySelectorAll(".swiper-slide").length;
      section.mmTestimonialsSwiper = new window.Swiper(container, {
        slidesPerView: 1.1,
        centeredSlides: true,
        spaceBetween: 16,
        loop: slidesCount > 3,
        speed: 500,
        pagination: {
          el: section.querySelector(".mm-testimonials__pagination"),
          clickable: true
        },
        navigation: {
          nextEl: section.querySelector(".mm-testimonials__arrow--next"),
          prevEl: section.querySelector(".mm-testimonials__arrow--prev")
        },
        breakpoints: {
          750: {
            slidesPerView: 2.1,
            spaceBetween: 24
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        }
      });

      section.dataset.mmTestimonialsInit = "true";
    });
  }

  function destroySection(section) {
    if (!section || !section.mmTestimonialsSwiper) return;
    section.mmTestimonialsSwiper.destroy(true, true);
    section.mmTestimonialsSwiper = null;
    section.dataset.mmTestimonialsInit = "false";
  }

  function initAll() {
    document.querySelectorAll('[data-mm-testimonials="true"]').forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector('[data-mm-testimonials="true"]'));
  });

  document.addEventListener("shopify:section:unload", function (event) {
    destroySection(event.target.querySelector('[data-mm-testimonials="true"]'));
  });
})();
